import { WorkflowStatusProvider } from '../WorkflowStatus/WorkflowStatusProvider'
import { WorkflowStatus } from '../WorkflowStatus/WorkflowStatus'
import { AssigneeType, Property, SelectPropertyValue } from 'api/clients/PropertyClient'
import { IWorkflow } from 'stores/Workflows/Types'
import { useFolder } from 'hooks/queries/folders/useFolder'
import { Workflow } from 'stores/Workflows/Workflow'
import { State } from 'stores/Workflows/State'
import { Permission } from 'types'

interface Props {
  folder: IWorkflow['folder']
  property: Property<SelectPropertyValue>
  workflow: Workflow
  projectId: string
}

export const ProjectWorkflowPropertyValue = ({ projectId, folder, workflow, property }: Props) => {
  const assignee = { id: projectId, type: AssigneeType.Project }
  const { data } = useFolder(projectId)

  const canEdit = data?.folder?.has_edit_access || false
  const canTransitionTo: State['key'][] = []
  if (canEdit) {
    property.property_values.forEach((value) => canTransitionTo.push(value.id + ''))
  }

  return (
    <WorkflowStatusProvider
      workflow={workflow}
      assignee={assignee}
      property={property}
      folder={folder}
      permissions={{
        can_transition_to: canTransitionTo,
        can_read: true,
        can_edit: false,
        can_edit_content: false,
        access: Permission.Read,
      }}
    >
      <WorkflowStatus />
    </WorkflowStatusProvider>
  )
}
